import {setError} from '../reducers/error';
import {get, isEmpty, noop,} from 'lodash-es';
import {all, call, put, select, takeLatest} from 'redux-saga/effects';
import {
    fetch_future_list_v2,
    fetch_scrip_details_v2,
    fetch_valuation,
    get_agm_egm_data,
    get_board_meetings_data,
    get_book_closure,
    get_buy_back,
    get_corporate_action_calendar_data,
    get_dividend_data,
    get_index_constituents_data,
    get_rights_data,
    get_scrip_analyst_data,
    get_scrip_company_balance_sheet_data,
    get_scrip_company_result,
    get_scrip_company_wise_mf_holding_data,
    get_scrip_financial_ratio,
    get_scrip_moving_average,
    get_scrip_peer_comparison,
    get_scrip_profit_loss_data,
    get_scrip_quarterly_trend,
    get_scrip_security_info,
    get_scrip_volume_vs_delivery,
    get_scrip_wise_news_data,
    get_share_holding_pattern_data,
    get_splits_data,
} from '../../apis/scripDetail';
import {API_SEGMENT_LABEL_MAPPER, SCRIP_PULL_REFRESH_SCREEN, TREND_ANALYSIS_DATA,} from '../../constants/scripDetail';

import {formatAnnualReportData} from '../../utils/scripDetail/Fundamental';
import {getLastSixMonthDate} from '../../utils/scripDetail/News';
import {
    canMakeWaveApiCall,
    getScripDetailPullRefreshError,
    getShouldRefreshStructure
} from '../../utils/scripDetail/wave';
import scripDetailsService from '../../services/scripDetailService';
import commonBaseService from '../../services/commonBaseService';

import {
    fetchFnoTabData,
    fetchScripDetails,
    fetchValuation,
    getAgm,
    getAgmData,
    getAnalystData,
    getAnnualReport,
    getAnnualReportBalanceSheetData,
    getAnnualReportProfitData,
    getAnnualReportResultsData,
    getBalanceSheetAnnualReport,
    getBoardMeeting,
    getBoardMeetingData,
    getBonus,
    getBonusData,
    getBookClosure,
    getBookClosureData,
    getBuyback,
    getBuybackData,
    getConstituentsData,
    getConstituentsValue,
    getDividend,
    getDividendData,
    getEgm,
    getEgmData,
    getFinancialRatio,
    getMfFundHolders,
    getMovingAverage,
    getMovingAverageData,
    getNewsData,
    getPeerComparison,
    getPeerComparisonData,
    getProfitLossAnnualReport,
    getResultsAnnualReport,
    getRights,
    getRightsData,
    getScripAnalystData,
    getScripNewsData,
    getSecurityInfo,
    getSecurityInfoData,
    getSelectedFinancialRatioData,
    getSelectedScripDetails,
    getShareHolding,
    getShareHoldingData,
    getSplit,
    getSplitData,
    getTopHoldingsData,
    getTrendAnalysis,
    getTrendAnalysisData,
    getVolumeDeliveryChart,
    getVolumeDeliveryChartData,
    pullRefreshAnalystScrip,
    pullRefreshConstituentsScrip,
    pullRefreshFundamentalScrip,
    pullRefreshNewsEventScrip,
    pullRefreshOverviewScrip,
    pullRefreshTechnicalScrip,
    setAgm,
    setAnalystData,
    setAnnualReport,
    setAnnualReportBalanceSheetData,
    setAnnualReportProfitData,
    setAnnualReportResultsData,
    setBoardMeeting,
    setBonus,
    setBookClosure,
    setBuyback,
    setConstituentsData,
    setDividend,
    setEgm,
    setFinancialRatio,
    setFnoTabData,
    setInitialData,
    setMfFundHolders,
    setMovingAverage,
    setNewsData,
    setPeerComparison,
    setPullScripDetailErrorState,
    setPullScripDetailLoadingState,
    setRights,
    setScripDetails,
    setScripDetailsParams,
    setSecurityInfo,
    setShareHolding,
    setSplit,
    setTrendAnalysis,
    setValuation,
    setVolumeDeliveryChart
} from '../reducers/equity/scripDetails/scripDetail';
import {isEmptyOrUndefined} from '../../utils/common/validators';
import {setLoader} from '../reducers/loader';
import {resetScripDetailsError, setScripDetailsError} from '../reducers/equity/scripDetails/scripDetailsError';
import {setScripDetailsLoader} from '../reducers/equity/scripDetails/scripDetailsLoader';
import {setScripDetailsLookUpData} from "../reducers/equity/scripDetails/scripDetailsLookUpData";
import {
    setScripDetailsActionLoaderFalse,
    setScripDetailsActionLoaderTrue
} from "../reducers/equity/scripDetails/scripDetailsActionLoader";
import {setScripDetailsActionError} from "../reducers/equity/scripDetails/scripDetailsActionError";

function* handleFetchFinancialRatio({ payload }) {
    const {
        Api,
        marketSegmentId,
        nToken,
        shouldRefresh,
        isPullToRefresh = false,
        pullRefreshScreen = '',
        foreignKey,
        screenId,
    } = payload;

    try {
        let {
            shouldRefresh: storeShouldRefresh,
            nextRefreshTime: storeNextRefreshTime,
            data: storeData,
            isUiCacheEnabled: storeisUiCacheEnabled,
        } = yield select(getSelectedFinancialRatioData, foreignKey);
        const standaloneStoreData = get(storeData, 'standalone', {});
        const consolidatedStoreData = get(storeData, 'consolidated', {});
        storeShouldRefresh =
            isEmpty(standaloneStoreData) || isEmpty(consolidatedStoreData);
        const isApiCallRequired = canMakeWaveApiCall(
            storeisUiCacheEnabled,
            storeShouldRefresh,
            storeNextRefreshTime,
            storeData,
        );
        if (!isApiCallRequired && !isPullToRefresh) return;
        if (!isPullToRefresh) {
            yield put(setFinancialRatio({ isLoading: true, error: '', foreignKey }));
        }
        const standaloneResponse = yield call(
            get_scrip_financial_ratio,
            Api,
            marketSegmentId,
            nToken,
            'S',
        );
        const standalone = get(
            standaloneResponse,
            'get_company_financial_ratio_data',
            {},
        );
        const standaloneData = get(standalone, 'data', []);
        const consolidatedResponse = yield call(
            get_scrip_financial_ratio,
            Api,
            marketSegmentId,
            nToken,
            'C',
        );
        const consolidated = get(
            consolidatedResponse,
            'get_company_financial_ratio_data',
            {},
        );
        const consolidatedData = get(consolidated, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            consolidated,
            shouldRefresh,
        );
        yield put(
            setFinancialRatio({
                isLoading: false,
                data: {
                    standalone: standaloneData,
                    consolidated: consolidatedData,
                },
                foreignKey,
                ...refreshDetails,
            }),
        );
    } catch (error) {
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            const errorMessage = getScripDetailPullRefreshError(error);
            yield put(
                setPullScripDetailErrorState({
                    [pullRefreshScreen]: { status: true, errorMessage },
                }),
            );
        } else {
            yield put(setFinancialRatio({ error: error?.message, foreignKey }));
        }
        console.log('handleFetchFinancialRatio error is', error.message);
    } finally {
        yield put(setFinancialRatio({ isLoading: false, foreignKey }));
    }
}

function* handleFetchTrendAnalysis({ payload }) {
    const {
        Api,
        exchange,
        nToken,
        shouldRefresh,
        trendType,
        isPullToRefresh = false,
        pullRefreshScreen = '',
        foreignKey,
        screenId,
    } = payload;
    try {
        const {
            shouldRefresh: storeShouldRefresh,
            nextRefreshTime: storeNextRefreshTime,
            data: storeData,
            isUiCacheEnabled: storeisUiCacheEnabled,
        } = yield select(getTrendAnalysisData, foreignKey);
        const isApiCallRequired = canMakeWaveApiCall(
            storeisUiCacheEnabled,
            storeShouldRefresh,
            storeNextRefreshTime,
            storeData[trendType],
        );
        if (!isApiCallRequired && !isPullToRefresh) return;
        if (!isPullToRefresh) {
            yield put(setTrendAnalysis({ isLoading: true, error: {}, foreignKey }));
        }
        const response = yield call(
            get_scrip_quarterly_trend,
            Api,
            exchange,
            nToken,
            trendType,
        );
        const trendAnalysis = get(response, 'get_quarterly_trend', {});
        const trendData = get(trendAnalysis, 'data', []);
        const data = { ...storeData } || {};
        data[trendType] = trendData;
        const refreshDetails = getShouldRefreshStructure(
            trendAnalysis,
            shouldRefresh,
        );
        yield put(
            setTrendAnalysis({ isLoading: false, data, ...refreshDetails, foreignKey }),
        );
    } catch (error) {
        const errorPayload = {
            [trendType]: error?.message,
        };
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            const errorMessage = getScripDetailPullRefreshError(error);
            yield put(
                setPullScripDetailErrorState({
                    foreignKey,
                    [pullRefreshScreen]: { status: true, errorMessage },
                }),
            );
        } else {
            yield put(setTrendAnalysis({ error: errorPayload, foreignKey }));
        }
        console.log('handleFetchTrendAnalysis error is', error.message);
    } finally {
        yield put(setTrendAnalysis({ isLoading: false, foreignKey }));
    }
}

function* handleFetchMfFundHolder({ payload }) {
    const {
        Api,
        marketSegmentId,
        nToken,
        shouldRefresh,
        isPullToRefresh = false,
        pullRefreshScreen = '',
        foreignKey,
        screenId,
    } = payload;

    try {
        const {
            shouldRefresh: storeShouldRefresh,
            nextRefreshTime: storeNextRefreshTime,
            data: storeData,
            isUiCacheEnabled: storeisUiCacheEnabled,
        } = yield select(getTopHoldingsData, foreignKey);
        const isApiCallRequired = canMakeWaveApiCall(
            storeisUiCacheEnabled,
            storeShouldRefresh,
            storeNextRefreshTime,
            storeData,
        );
        if (!isApiCallRequired && !isPullToRefresh) return;
        if (!isPullToRefresh) {
            yield put(setMfFundHolders({ isLoading: true, error: '', foreignKey }));
        }
        const response = yield call(
            get_scrip_company_wise_mf_holding_data,
            Api,
            marketSegmentId,
            nToken,
        );
        const topMfHolding = get(
            response,
            'get_company_wise_mf_holding_data',
            {},
        );
        const data = get(topMfHolding, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            topMfHolding,
            shouldRefresh,
        );
        yield put(
            setMfFundHolders({ isLoading: false, data, ...refreshDetails, foreignKey }),
        );
    } catch (error) {
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            const errorMessage = getScripDetailPullRefreshError(error);
            yield put(
                setPullScripDetailErrorState({
                    foreignKey,
                    [pullRefreshScreen]: { status: true, errorMessage },
                }),
            );
        } else {
            yield put(setMfFundHolders({ error: error?.message, foreignKey }));
        }
        console.log('handleFetchMfFundHolder error is', error.message);
    } finally {
        yield put(setMfFundHolders({ isLoading: false, foreignKey }));
    }
}

function* handleFetchPeerComparison({ payload }) {
    const {
        Api,
        marketSegmentId,
        nToken,
        shouldRefresh,
        isPullToRefresh = false,
        pullRefreshScreen = '',
        foreignKey,
        screenId,
    } = payload;

    try {
        const {
            shouldRefresh: storeShouldRefresh,
            nextRefreshTime: storeNextRefreshTime,
            data: storeData,
            isUiCacheEnabled: storeisUiCacheEnabled,
        } = yield select(getPeerComparisonData, foreignKey);
        const isApiCallRequired = canMakeWaveApiCall(
            storeisUiCacheEnabled,
            storeShouldRefresh,
            storeNextRefreshTime,
            storeData,
        );
        if (!isApiCallRequired && !isPullToRefresh) return;
        if (!isPullToRefresh) {
            yield put(setPeerComparison({ isLoading: true, error: '', foreignKey }));
        }
        const response = yield call(
            get_scrip_peer_comparison,
            Api,
            marketSegmentId,
            nToken,
        );
        const peerComparisonData = get(response, 'get_peer_comparison', {});
        const data = get(peerComparisonData, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            peerComparisonData,
            shouldRefresh,
        );
        yield put(
            setPeerComparison({ isLoading: false, data, ...refreshDetails, foreignKey }),
        );
    } catch (error) {
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            const errorMessage = getScripDetailPullRefreshError(error);
            yield put(
                setPullScripDetailErrorState({
                    foreignKey,
                    [pullRefreshScreen]: { status: true, errorMessage },
                }),
            );
        } else {
            yield put(setPeerComparison({ error: error?.message, foreignKey }));
        }
        console.log('handleFetchPeerComparison error is', error?.message);
    } finally {
        yield put(setPeerComparison({ isLoading: false, foreignKey }));
    }
}

function* handleFetchAnnualReport({ payload }) {
    try {
        const { Api, marketSegmentId, nToken } = payload;
        yield put(setAnnualReport({ isLoading: true }));
        let standAloneBalanceSheet = yield call(
            get_scrip_company_balance_sheet_data,
            Api,
            marketSegmentId,
            nToken,
            'S',
        );
        standAloneBalanceSheet = get(
            standAloneBalanceSheet,
            'get_company_balance_sheet_data.data',
            [],
        );
        let consolidatedBalanceSheet = yield call(
            get_scrip_company_balance_sheet_data,
            Api,
            marketSegmentId,
            nToken,
            'C',
        );
        consolidatedBalanceSheet = get(
            consolidatedBalanceSheet,
            'get_company_balance_sheet_data.data',
            [],
        );
        let standAloneProfitLoss = yield call(
            get_scrip_profit_loss_data,
            Api,
            marketSegmentId,
            nToken,
            'S',
        );
        standAloneProfitLoss = get(
            standAloneProfitLoss,
            'get_profit_loss_data.data',
            [],
        );
        let consolidatedProfitLoss = yield call(
            get_scrip_profit_loss_data,
            Api,
            marketSegmentId,
            nToken,
            'C',
        );
        consolidatedProfitLoss = get(
            consolidatedProfitLoss,
            'get_profit_loss_data.data',
            [],
        );
        let standAloneCompanyResult = yield call(
            get_scrip_company_result,
            Api,
            marketSegmentId,
            nToken,
            'S',
        );
        standAloneCompanyResult = get(
            standAloneCompanyResult,
            'get_company_result_data.data',
            [],
        );
        let consolidatedCompanyResult = yield call(
            get_scrip_company_result,
            Api,
            marketSegmentId,
            nToken,
            'C',
        );
        consolidatedCompanyResult = get(
            consolidatedCompanyResult,
            'get_company_result_data.data',
            [],
        );
        const response = {
            profitLoss: {
                standalone: standAloneProfitLoss,
                consolidated: consolidatedProfitLoss,
            },
            balanceSheet: {
                standalone: standAloneBalanceSheet,
                consolidated: consolidatedBalanceSheet,
            },
            results: {
                standalone: standAloneCompanyResult,
                consolidated: consolidatedCompanyResult,
            },
        };
        yield put(setAnnualReport({ isLoading: false, ...response }));
    } catch (error) {
        console.log('handleFetchAnnualReport error is', error.message);
    } finally {
        yield put(setAnnualReport({ isLoading: false }));
    }
}

function* handleFetchAnalystData({ payload }) {
    const {
        Api,
        isin,
        ltp = '',
        isPullToRefresh = false,
        pullRefreshScreen = '',
        foreignKey,
        screenId,
    } = payload;
    try {
        const {
            shouldRefresh,
            nextRefreshTime,
            data,
            isUiCacheEnabled: storeisUiCacheEnabled,
        } = yield select(getScripAnalystData, foreignKey);
        const isApiCallRequired = canMakeWaveApiCall(
            storeisUiCacheEnabled,
            shouldRefresh,
            nextRefreshTime,
            data,
        );
        if (!isApiCallRequired && !isPullToRefresh) {
            return;
        }
        if (isEmpty(data)) {
            yield put(setAnalystData({ isLoading: true, foreignKey }));
            yield put(setScripDetailsActionLoaderTrue({ actionName: getAnalystData, screenId }));
        }
        const response = yield call(get_scrip_analyst_data, Api, isin, ltp);
        const resultData = get(response, 'result_data', {});
        const refreshDetails = getShouldRefreshStructure(
            response,
            shouldRefresh,
        );
        yield put(
            setAnalystData({
                foreignKey,
                isLoading: false,
                data: resultData,
                ...refreshDetails,
            }),
        );
    } catch (error) {
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            const errorMessage = getScripDetailPullRefreshError(error);
            yield put(
                setPullScripDetailErrorState({
                    foreignKey,
                    [pullRefreshScreen]: { status: true, errorMessage },
                }),
            );
        }
        console.log('handleFetchAnalystData error is', error.message);
    } finally {
        yield put(setAnalystData({ isLoading: false, foreignKey }));
        yield put(setScripDetailsActionLoaderFalse({ actionName: getAnalystData, screenId }));
    }
}

function* handleFetchMovingAverage({ payload }) {
    const {
        Api,
        shouldRefresh,
        isPullToRefresh = false,
        pullRefreshScreen = '',
        foreignKey,
        screenId
    } = payload;
    try {
        const {
            shouldRefresh: storeShouldRefresh,
            nextRefreshTime: storeNextRefreshTime,
            data: storeData,
            isUiCacheEnabled: storeisUiCacheEnabled,
        } = yield select(getMovingAverageData, foreignKey);
        const isApiCallRequired = canMakeWaveApiCall(
            storeisUiCacheEnabled,
            storeShouldRefresh,
            storeNextRefreshTime,
            storeData,
        );
        if (!isApiCallRequired && !isPullToRefresh) return;
        if (!isPullToRefresh) {
            yield put(setMovingAverage({ isLoading: true, error: '', foreignKey }));
        }
        const scripDetailsData = yield select(getSelectedScripDetails, foreignKey);
        const nseToken = get(scripDetailsData, 'nse_data.token', '');
        const bseToken = get(scripDetailsData, 'bse_data.token', '');
        const nseResponse = yield call(
            get_scrip_moving_average,
            Api,
            nseToken,
            'NSE_EQ',
        );
        const nseMovingAverage = get(nseResponse, 'get_moving_average', {});
        const nseData = get(nseMovingAverage, 'data.0', {});
        const bseResponse = yield call(
            get_scrip_moving_average,
            Api,
            bseToken,
            'BSE_EQ',
        );
        const bseMovingAverage = get(bseResponse, 'get_moving_average', {});
        const bseData = get(bseMovingAverage, 'data.0', {});
        const refreshDetails = getShouldRefreshStructure(
            bseMovingAverage,
            shouldRefresh,
        );
        const response = {
            data: {
                NSE: nseData,
                BSE: bseData,
            },
            ...refreshDetails,
        };
        yield put(setMovingAverage({ isLoading: false, ...response, foreignKey }));
    } catch (error) {
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            const errorMessage = getScripDetailPullRefreshError(error);
            yield put(
                setPullScripDetailErrorState({
                    foreignKey,
                    [pullRefreshScreen]: { status: true, errorMessage },
                }),
            );
        } else {
            yield put(setMovingAverage({ error: error?.message, foreignKey }));
        }
        console.log('handleFetchMovingAverage error is', error.message);
    } finally {
        yield put(setMovingAverage({ isLoading: false, foreignKey }));
    }
}

function* handleFetchVolumeDeliveryChart({ payload }) {
    const {
        Api,
        nToken,
        marketSegmentId,
        shouldRefresh,
        isPullToRefresh = false,
        pullRefreshScreen = '',
        foreignKey,
        screenId
    } = payload;
    try {
        const {
            shouldRefresh: storeShouldRefresh,
            nextRefreshTime: storeNextRefreshTime,
            data: storeData,
            isUiCacheEnabled: storeisUiCacheEnabled,
        } = yield select(getVolumeDeliveryChartData, foreignKey);
        const isApiCallRequired = canMakeWaveApiCall(
            storeisUiCacheEnabled,
            storeShouldRefresh,
            storeNextRefreshTime,
            storeData,
        );
        if (!isApiCallRequired && !isPullToRefresh) return;
        if (!isPullToRefresh) {
            yield put(setVolumeDeliveryChart({ isLoading: true, error: '', foreignKey }));
        }
        const response = yield call(
            get_scrip_volume_vs_delivery,
            Api,
            marketSegmentId,
            nToken,
        );
        const volumeDelivery = get(response, 'get_volume_vs_delivery', {});
        const data = get(volumeDelivery, 'data.0', {});
        const refreshDetails = getShouldRefreshStructure(
            volumeDelivery,
            shouldRefresh,
        );
        yield put(
            setVolumeDeliveryChart({
                isLoading: false,
                data,
                foreignKey,
                ...refreshDetails,
            }),
        );
    } catch (error) {
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            const errorMessage = getScripDetailPullRefreshError(error);
            yield put(
                setPullScripDetailErrorState({
                    foreignKey,
                    [pullRefreshScreen]: { status: true, errorMessage },
                }),
            );
        } else {
            yield put(setVolumeDeliveryChart({ error: error?.message, foreignKey }));
        }
        console.log('handleFetchVolumeDeliveryChart error is', error.message);
    } finally {
        yield put(setVolumeDeliveryChart({ isLoading: false, foreignKey }));
    }
}

function* handleFetchSecurityInfo({ payload }) {
    const {
        Api,
        nToken,
        marketSegmentId,
        isPullToRefresh = false,
        pullRefreshScreen = '',
        foreignKey,
        screenId,
    } = payload;
    try {
        const {
            shouldRefresh: storeShouldRefresh,
            nextRefreshTime: storeNextRefreshTime,
            data: storeData,
            isUiCacheEnabled: storeisUiCacheEnabled,
        } = yield select(getSecurityInfoData, foreignKey);
        const isApiCallRequired = canMakeWaveApiCall(
            storeisUiCacheEnabled,
            storeShouldRefresh,
            storeNextRefreshTime,
            storeData,
        );
        if (!isApiCallRequired && !isPullToRefresh) return;
        if (!isPullToRefresh) {
            yield put(setSecurityInfo({ isLoading: true, error: '', foreignKey }));
        }
        const data = yield call(
            get_scrip_security_info,
            Api,
            marketSegmentId,
            nToken,
        );
        yield put(setSecurityInfo({ isLoading: false, data, foreignKey }));
    } catch (error) {
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            const errorMessage = getScripDetailPullRefreshError(error);
            yield put(
                setPullScripDetailErrorState({
                    foreignKey,
                    [pullRefreshScreen]: { status: true, errorMessage, foreignKey },
                }),
            );
        } else {
            yield put(setSecurityInfo({ error: error?.message, foreignKey }));
        }
        console.log('handleFetchSecurityInfo error is', error.message);
    } finally {
        yield put(setSecurityInfo({ isLoading: false, foreignKey }));
    }
}

function* handleFetchNewsData({ payload }) {
    const {
        Api,
        marketSegmentId,
        nToken,
        shouldRefresh,
        isPullToRefresh = false,
        pullRefreshScreen = '',
        foreignKey,
        screenId,
    } = payload;

    const {
        shouldRefresh: storeShouldRefresh,
        nextRefreshTime: storeNextRefreshTime,
        data: storeData,
        isUiCacheEnabled: storeisUiCacheEnabled,
    } = yield select(getScripNewsData, foreignKey);
    const isApiCallRequired = canMakeWaveApiCall(
        storeisUiCacheEnabled,
        storeShouldRefresh,
        storeNextRefreshTime,
        storeData,
    );
    if (!isApiCallRequired && !isPullToRefresh) return;
    try {
        if (!isPullToRefresh) {
            yield put(setNewsData({ isLoading: true, error: '', foreignKey }));
        }
        const newsDataResponse = yield call(
            get_scrip_wise_news_data,
            Api,
            marketSegmentId,
            nToken,
        );
        const newsData = get(newsDataResponse, 'get_scrip_wise_news_data', {});
        const data = get(newsData, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            newsData,
            shouldRefresh,
        );
        yield put(setNewsData({ isLoading: false, data, ...refreshDetails, foreignKey }));
    } catch (error) {
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            const errorMessage = getScripDetailPullRefreshError(error);
            yield put(
                setPullScripDetailErrorState({
                    foreignKey,
                    [pullRefreshScreen]: { status: true, errorMessage },
                }),
            );
        } else {
            yield put(setNewsData({ error: error?.message, foreignKey }));
        }
        console.log('handleFetchNewsData error is', error?.message);
    } finally {
        yield put(setNewsData({ isLoading: false, foreignKey }));
    }
}

function* handleFetchBoardMeeting({ payload }) {
    const {
        Api,
        marketSegmentId,
        nToken,
        fromDate,
        toDate,
        shouldRefresh,
        isPullToRefresh = false,
        pullRefreshScreen = '',
        foreignKey,
        screenId,
    } = payload;

    const {
        shouldRefresh: storeShouldRefresh,
        nextRefreshTime: storeNextRefreshTime,
        data: storeData,
        isUiCacheEnabled: storeisUiCacheEnabled,
    } = yield select(getBoardMeetingData, foreignKey);
    const isApiCallRequired = canMakeWaveApiCall(
        storeisUiCacheEnabled,
        storeShouldRefresh,
        storeNextRefreshTime,
        storeData,
    );
    if (!isApiCallRequired && !isPullToRefresh) return;
    try {
        if (!isPullToRefresh) {
            yield put(setBoardMeeting({ isLoading: true, foreignKey }));
        }
        const boardMeetingResponse = yield call(
            get_board_meetings_data,
            Api,
            marketSegmentId,
            nToken,
            fromDate,
            toDate,
        );
        const boardMeetingData = get(
            boardMeetingResponse,
            'get_board_meetings_data',
            {},
        );
        const data = get(boardMeetingData, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            boardMeetingData,
            shouldRefresh,
        );
        yield put(
            setBoardMeeting({ isLoading: false, data, ...refreshDetails, foreignKey }),
        );
    } catch (error) {
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            const errorMessage = getScripDetailPullRefreshError(error);
            yield put(
                setPullScripDetailErrorState({
                    foreignKey,
                    [pullRefreshScreen]: { status: true, errorMessage },
                }),
            );
        }
        console.log('handleFetchBoardMeeting error is', error.message);
    } finally {
        yield put(setBoardMeeting({ isLoading: false, foreignKey }));
    }
}

function* handleFetchBookClosure({ payload }) {
    const { Api, marketSegmentId, nToken, shouldRefresh, foreignKey, screenId, } = payload;

    const {
        shouldRefresh: storeShouldRefresh,
        nextRefreshTime: storeNextRefreshTime,
        data: storeData,
        isUiCacheEnabled: storeisUiCacheEnabled,
    } = yield select(getBookClosureData, foreignKey);
    const isApiCallRequired = canMakeWaveApiCall(
        storeisUiCacheEnabled,
        storeShouldRefresh,
        storeNextRefreshTime,
        storeData,
    );
    if (!isApiCallRequired) return;
    try {
        yield put(setBookClosure({ isLoading: true, error: '', foreignKey }));
        const bookClosureResponse = yield call(
            get_book_closure,
            Api,
            marketSegmentId,
            nToken,
        );
        const bookClosureData = get(
            bookClosureResponse,
            'get_book_closure',
            {},
        );
        const data = get(bookClosureData, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            bookClosureData,
            shouldRefresh,
        );
        yield put(
            setBookClosure({ isLoading: false, data, ...refreshDetails, foreignKey }),
        );
    } catch (error) {
        yield put(setBookClosure({ error: error?.message, foreignKey }));
        console.log('handleFetchBookClosure error is', error.message);
    } finally {
        yield put(setBookClosure({ isLoading: false, foreignKey }));
    }
}

function* handleFetchRights({ payload }) {
    const { Api, exchange, nToken, shouldRefresh, foreignKey, screenId } = payload;
    const {
        shouldRefresh: storeShouldRefresh,
        nextRefreshTime: storeNextRefreshTime,
        data: storeData,
        isUiCacheEnabled: storeisUiCacheEnabled,
    } = yield select(getRightsData, foreignKey);
    const isApiCallRequired = canMakeWaveApiCall(
        storeisUiCacheEnabled,
        storeShouldRefresh,
        storeNextRefreshTime,
        storeData,
    );
    if (!isApiCallRequired) return;
    try {
        yield put(setRights({ isLoading: true, foreignKey }));
        const rightsDataResponse = yield call(
            get_rights_data,
            Api,
            exchange,
            nToken,
        );
        const rightsData = get(rightsDataResponse, 'get_rights_data', {});
        const data = get(rightsData, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            rightsData,
            shouldRefresh,
        );
        yield put(setRights({ isLoading: false, data, ...refreshDetails, foreignKey }));
    } catch (error) {
        console.log('handleFetchRights error is', error.message);
    } finally {
        yield put(setRights({ isLoading: false, foreignKey }));
    }
}

function* handleFetchAgm({ payload }) {
    const { Api, marketSegmentId, nToken, fromDate, toDate, shouldRefresh, foreignKey, screenId } =
        payload;
    const {
        shouldRefresh: storeShouldRefresh,
        nextRefreshTime: storeNextRefreshTime,
        data: storeData,
        isUiCacheEnabled: storeisUiCacheEnabled,
    } = yield select(getAgmData, foreignKey);
    const isApiCallRequired = canMakeWaveApiCall(
        storeisUiCacheEnabled,
        storeShouldRefresh,
        storeNextRefreshTime,
        storeData,
    );
    if (!isApiCallRequired) return;

    try {
        yield put(setAgm({ isLoading: true, foreignKey }));
        const agmEgmResponse = yield call(
            get_agm_egm_data,
            Api,
            'AGM',
            marketSegmentId,
            nToken,
            fromDate,
            toDate,
        );
        const agmEgmData = get(agmEgmResponse, 'get_agm_egm_data', {});
        const data = get(agmEgmData, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            agmEgmData,
            shouldRefresh,
        );
        yield put(setAgm({ isLoading: false, data, ...refreshDetails, foreignKey }));
    } catch (error) {
        console.log('handleFetchAgm error is', error.message);
    } finally {
        yield put(setAgm({ isLoading: false, foreignKey }));
    }
}

function* handleFetchEgm({ payload }) {
    const { Api, marketSegmentId, nToken, fromDate, toDate, shouldRefresh, foreignKey, screenId  } =
        payload;
    const {
        shouldRefresh: storeShouldRefresh,
        nextRefreshTime: storeNextRefreshTime,
        data: storeData,
        isUiCacheEnabled: storeisUiCacheEnabled,
    } = yield select(getEgmData, foreignKey);
    const isApiCallRequired = canMakeWaveApiCall(
        storeisUiCacheEnabled,
        storeShouldRefresh,
        storeNextRefreshTime,
        storeData,
    );
    if (!isApiCallRequired) return;

    try {
        yield put(setEgm({ isLoading: true, foreignKey }));
        const agmEgmResponse = yield call(
            get_agm_egm_data,
            Api,
            'EGM',
            marketSegmentId,
            nToken,
            fromDate,
            toDate,
        );
        const agmEgmData = get(agmEgmResponse, 'get_agm_egm_data', {});
        const data = get(agmEgmData, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            agmEgmData,
            shouldRefresh,
        );
        yield put(setEgm({ isLoading: false, data, ...refreshDetails, foreignKey }));
    } catch (error) {
        console.log('handleFetchEgm error is', error.message);
    } finally {
        yield put(setEgm({ isLoading: false, foreignKey }));
    }
}

function* handleFetchSplit({ payload }) {
    const { Api, marketSegmentId, nToken, fromDate, toDate, shouldRefresh, foreignKey, screenId } =
        payload;
    const {
        shouldRefresh: storeShouldRefresh,
        nextRefreshTime: storeNextRefreshTime,
        data: storeData,
        isUiCacheEnabled: storeisUiCacheEnabled,
    } = yield select(getSplitData, foreignKey);
    const isApiCallRequired = canMakeWaveApiCall(
        storeisUiCacheEnabled,
        storeShouldRefresh,
        storeNextRefreshTime,
        storeData,
    );
    if (!isApiCallRequired) return;

    try {
        yield put(setSplit({ isLoading: true, foreignKey }));
        const splitDataResponse = yield call(
            get_splits_data,
            Api,
            marketSegmentId,
            nToken,
            fromDate,
            toDate,
        );
        const splitData = get(splitDataResponse, 'get_splits_data', {});
        const data = get(splitData, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            splitData,
            shouldRefresh,
        );
        yield put(setSplit({ isLoading: false, data, ...refreshDetails, foreignKey }));
    } catch (error) {
        console.log('handleFetchSplit error is', error.message);
    } finally {
        yield put(setSplit({ isLoading: false, foreignKey }));
    }
}

function* handleFetchDividend({ payload }) {
    const { Api, marketSegmentId, nToken, fromDate, toDate, shouldRefresh, foreignKey, screenId } =
        payload;
    const {
        shouldRefresh: storeShouldRefresh,
        nextRefreshTime: storeNextRefreshTime,
        data: storeData,
        isUiCacheEnabled: storeisUiCacheEnabled,
    } = yield select(getDividendData, foreignKey);
    const isApiCallRequired = canMakeWaveApiCall(
        storeisUiCacheEnabled,
        storeShouldRefresh,
        storeNextRefreshTime,
        storeData,
    );
    if (!isApiCallRequired) return;

    try {
        yield put(setDividend({ isLoading: true, foreignKey }));
        const dividendResponse = yield call(
            get_dividend_data,
            Api,
            marketSegmentId,
            nToken,
            fromDate,
            toDate,
        );
        const dividendData = get(dividendResponse, 'get_dividend_data', {});
        const data = get(dividendData, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            dividendData,
            shouldRefresh,
        );
        yield put(setDividend({ isLoading: false, data, ...refreshDetails, foreignKey }));
    } catch (error) {
        console.log('handleFetchDividend error is', error.message);
    } finally {
        yield put(setDividend({ isLoading: false, foreignKey }));
    }
}

function* handleFetchBuyback({ payload }) {
    const { Api, marketSegmentId, nToken, shouldRefresh, foreignKey, screenId } = payload;
    const {
        shouldRefresh: storeShouldRefresh,
        nextRefreshTime: storeNextRefreshTime,
        data: storeData,
        isUiCacheEnabled: storeisUiCacheEnabled,
    } = yield select(getBuybackData, foreignKey);
    const isApiCallRequired = canMakeWaveApiCall(
        storeisUiCacheEnabled,
        storeShouldRefresh,
        storeNextRefreshTime,
        storeData,
    );
    if (!isApiCallRequired) return;
    try {
        yield put(setBuyback({ isLoading: true, foreignKey }));
        const buyBackResponse = yield call(
            get_buy_back,
            Api,
            marketSegmentId,
            nToken,
        );
        const buyBackData = get(buyBackResponse, 'get_buy_back', {});
        const data = get(buyBackData, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            buyBackData,
            shouldRefresh,
        );
        yield put(setBuyback({ isLoading: false, data, ...refreshDetails, foreignKey }));
    } catch (error) {
        console.log('handleFetchBuyback error is', error.message);
    } finally {
        yield put(setBuyback({ isLoading: false, foreignKey }));
    }
}

function* handleFetchBonus({ payload }) {
    const { Api, fromDate, toDate, shouldRefresh, foreignKey, screenId } = payload;
    const {
        shouldRefresh: storeShouldRefresh,
        nextRefreshTime: storeNextRefreshTime,
        data: storeData,
        isUiCacheEnabled: storeisUiCacheEnabled,
    } = yield select(getBonusData, foreignKey);
    const isApiCallRequired = canMakeWaveApiCall(
        storeisUiCacheEnabled,
        storeShouldRefresh,
        storeNextRefreshTime,
        storeData,
    );
    if (!isApiCallRequired) return;
    try {
        yield put(setBonus({ isLoading: true, foreignKey }));
        const bonusResponse = yield call(
            get_corporate_action_calendar_data,
            Api,
            'Bonus',
            fromDate,
            toDate,
        );
        const bonusData = get(
            bonusResponse,
            'get_corporate_action_calendar_data',
            {},
        );
        const data = get(bonusData, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            bonusData,
            shouldRefresh,
        );
        yield put(setBonus({ isLoading: false, data, ...refreshDetails, foreignKey }));
    } catch (error) {
        console.log('handleFetchBonus error is', error.message);
    } finally {
        yield put(setBonus({ isLoading: false, foreignKey }));
    }
}

function* handleFetchShareHoldings({ payload }) {
    const {
        Api,
        marketSegmentId,
        nToken,
        shouldRefresh,
        isPullToRefresh = false,
        pullRefreshScreen = '',
        foreignKey,
        screenId,
    } = payload;

    try {
        const {
            shouldRefresh: storeShouldRefresh,
            nextRefreshTime: storeNextRefreshTime,
            data: storeData,
            isUiCacheEnabled: storeisUiCacheEnabled,
        } = yield select(getShareHoldingData, foreignKey);
        const isApiCallRequired = canMakeWaveApiCall(
            storeisUiCacheEnabled,
            storeShouldRefresh,
            storeNextRefreshTime,
            storeData,
        );
        if (!isApiCallRequired && !isPullToRefresh) return;
        if (!isPullToRefresh) {
            yield put(setShareHolding({ isLoading: true, error: '', foreignKey }));
        }
        const response = yield call(
            get_share_holding_pattern_data,
            Api,
            marketSegmentId,
            nToken,
        );
        const shareHolding = get(
            response,
            'get_share_holding_pattern_data',
            {},
        );
        const data = get(shareHolding, 'data[0]', {});
        const refreshDetails = getShouldRefreshStructure(
            shareHolding,
            shouldRefresh,
        );
        yield put(
            setShareHolding({ isLoading: false, data, ...refreshDetails, foreignKey }),
        );
    } catch (error) {
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            const errorMessage = getScripDetailPullRefreshError(error);
            yield put(
                setPullScripDetailErrorState({
                    foreignKey,
                    [pullRefreshScreen]: { status: true, errorMessage },
                }),
            );
        } else {
            yield put(setShareHolding({ error: error?.message, foreignKey }));
        }
        console.log('handleFetchShareHoldings error is', error?.message);
    } finally {
        yield put(setShareHolding({ isLoading: false, foreignKey }));
    }
}

function* handleFetchConstituentsData({ payload }) {
    const {
        Api,
        exchange,
        indexGroup,
        shouldRefresh,
        pSize = 10,
        isPullToRefresh = false,
        pullRefreshScreen = '',
        foreignKey,
        screenId,
    } = payload;

    const {
        shouldRefresh: storeShouldRefresh,
        nextRefreshTime: storeNextRefreshTime,
        data: storeData,
        isUiCacheEnabled: storeisUiCacheEnabled,
    } = yield select(getConstituentsValue, foreignKey);
    const isApiCallRequired = canMakeWaveApiCall(
        storeisUiCacheEnabled,
        storeShouldRefresh,
        storeNextRefreshTime,
        storeData,
    );
    if (!isApiCallRequired && !isPullToRefresh) return;
    try {
        if (!isPullToRefresh) {
            yield put(setConstituentsData({ isLoading: true, foreignKey }));
        }
        const constituentResponse = yield call(
            get_index_constituents_data,
            Api,
            exchange,
            indexGroup,
            pSize,
        );
        const constituentData = get(
            constituentResponse,
            'get_index_constituents_data_v2',
            {},
        );
        const data = get(constituentData, 'data', []);
        const refreshDetails = getShouldRefreshStructure(
            constituentData,
            shouldRefresh,
        );
        yield put(
            setConstituentsData({ isLoading: false, data, foreignKey, ...refreshDetails }),
        );
    } catch (error) {
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            const errorMessage = getScripDetailPullRefreshError(error);
            yield put(
                setPullScripDetailErrorState({
                    foreignKey,
                    [pullRefreshScreen]: { status: true, errorMessage },
                }),
            );
        }
        console.log('handleFetchConstituentsData error is', error.message);
    } finally {
        yield put(setConstituentsData({ foreignKey, isLoading: false }));
    }
}
function* handleFetchProfitLossAnnualReport({ payload }) {
    const {
        Api,
        marketSegmentId,
        nToken,
        shouldRefresh,
        isPullToRefresh = false,
        pullRefreshScreen = '',
        foreignKey,
        screenId,
    } = payload;

    try {
        yield put(setAnnualReportProfitData({ isLoading: true, foreignKey }));
        let {
            shouldRefresh: storeShouldRefresh,
            nextRefreshTime: storeNextRefreshTime,
            data: storeData,
            isUiCacheEnabled: storeisUiCacheEnabled,
        } = yield select(getAnnualReportProfitData, foreignKey);
        const standaloneStoreData = get(storeData, 'standalone', {});
        const consolidatedStoreData = get(storeData, 'consolidated', {});
        storeShouldRefresh =
            isEmpty(standaloneStoreData) || isEmpty(consolidatedStoreData);
        const isApiCallRequired = canMakeWaveApiCall(
            storeisUiCacheEnabled,
            storeShouldRefresh,
            storeNextRefreshTime,
            storeData,
        );
        if (!isApiCallRequired && !isPullToRefresh) return;
        const standAloneProfitLossResponse = yield call(
            get_scrip_profit_loss_data,
            Api,
            marketSegmentId,
            nToken,
            'S',
        );
        const standAloneProfitLoss = get(
            standAloneProfitLossResponse,
            'get_profit_loss_data',
            {},
        );
        let standAloneProfitLossData = get(standAloneProfitLoss, 'data', []);
        standAloneProfitLossData = formatAnnualReportData(
            standAloneProfitLossData,
        );

        const consolidatedProfitLossResponse = yield call(
            get_scrip_profit_loss_data,
            Api,
            marketSegmentId,
            nToken,
            'C',
        );
        const consolidatedProfitLoss = get(
            consolidatedProfitLossResponse,
            'get_profit_loss_data',
            {},
        );
        let consolidatedProfitLossData = get(
            consolidatedProfitLoss,
            'data',
            [],
        );
        consolidatedProfitLossData = formatAnnualReportData(
            consolidatedProfitLossData,
        );

        const refreshDetails = getShouldRefreshStructure(
            consolidatedProfitLoss,
            shouldRefresh,
        );
        const response = {
            data: {
                standalone: standAloneProfitLossData,
                consolidated: consolidatedProfitLossData,
            },
            ...refreshDetails,
        };
        yield put(setAnnualReportProfitData({ isLoading: false, ...response, foreignKey }));
    } catch (error) {
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            const errorMessage = getScripDetailPullRefreshError(error);
            yield put(
                setPullScripDetailErrorState({
                    foreignKey,
                    [pullRefreshScreen]: { status: true, errorMessage },
                }),
            );
        } else {
            yield put(
                setAnnualReportProfitData({
                    isLoading: false,
                    error: error?.message,
                    foreignKey
                }),
            );
        }
        console.log(
            'handleFetchProfitLossAnnualReport error is',
            error.message,
        );
    }
}

function* handleFetchBalanceSheetAnnualReport({ payload }) {
    try {
        const { Api, marketSegmentId, nToken, shouldRefresh, foreignKey, screenId } = payload;
        yield put(setAnnualReportBalanceSheetData({ isLoading: true, foreignKey }));
        let {
            shouldRefresh: storeShouldRefresh,
            nextRefreshTime: storeNextRefreshTime,
            data: storeData,
            isUiCacheEnabled: storeisUiCacheEnabled,
        } = yield select(getAnnualReportBalanceSheetData, foreignKey);
        const standaloneStoreData = get(storeData, 'standalone', {});
        const consolidatedStoreData = get(storeData, 'consolidated', {});
        storeShouldRefresh =
            isEmpty(standaloneStoreData) || isEmpty(consolidatedStoreData);
        const isApiCallRequired = canMakeWaveApiCall(
            storeisUiCacheEnabled,
            storeShouldRefresh,
            storeNextRefreshTime,
            storeData,
        );
        if (!isApiCallRequired) return;
        const standAloneBalanceSheetResponse = yield call(
            get_scrip_company_balance_sheet_data,
            Api,
            marketSegmentId,
            nToken,
            'S',
        );
        const standAloneBalanceSheet = get(
            standAloneBalanceSheetResponse,
            'get_company_balance_sheet_data',
            {},
        );
        let standAloneBalanceSheetData = get(
            standAloneBalanceSheet,
            'data',
            [],
        );
        standAloneBalanceSheetData = formatAnnualReportData(
            standAloneBalanceSheetData,
        );

        const consolidatedBalanceSheetResponse = yield call(
            get_scrip_company_balance_sheet_data,
            Api,
            marketSegmentId,
            nToken,
            'C',
        );
        const consolidatedBalanceSheet = get(
            consolidatedBalanceSheetResponse,
            'get_company_balance_sheet_data',
            {},
        );
        let consolidatedBalanceSheetData = get(
            consolidatedBalanceSheet,
            'data',
            [],
        );
        consolidatedBalanceSheetData = formatAnnualReportData(
            consolidatedBalanceSheetData,
        );
        const refreshDetails = getShouldRefreshStructure(
            consolidatedBalanceSheet,
            shouldRefresh,
        );
        const response = {
            data: {
                standalone: standAloneBalanceSheetData,
                consolidated: consolidatedBalanceSheetData,
            },
            ...refreshDetails,
        };
        yield put(
            setAnnualReportBalanceSheetData({ isLoading: false, ...response, foreignKey }),
        );
    } catch (error) {
        yield put(
            setAnnualReportBalanceSheetData({
                isLoading: false,
                error: error?.message,
                foreignKey: payload.foreignKey,
            }),
        );
        console.log(
            'handleFetchBalanceSheetAnnualReport error is',
            error.message,
        );
    }
}

function* handleFetchResultsAnnualReport({ payload }) {
    try {
        const { Api, marketSegmentId, nToken, shouldRefresh, foreignKey, screenId } = payload;
        yield put(setAnnualReportResultsData({ isLoading: true, foreignKey }));
        let {
            shouldRefresh: storeShouldRefresh,
            nextRefreshTime: storeNextRefreshTime,
            data: storeData,
            isUiCacheEnabled: storeisUiCacheEnabled,
        } = yield select(getAnnualReportResultsData, foreignKey);
        const standaloneStoreData = get(storeData, 'standalone', {});
        const consolidatedStoreData = get(storeData, 'consolidated', {});
        storeShouldRefresh =
            isEmpty(standaloneStoreData) || isEmpty(consolidatedStoreData);
        const isApiCallRequired = canMakeWaveApiCall(
            storeisUiCacheEnabled,
            storeShouldRefresh,
            storeNextRefreshTime,
            storeData,
        );
        if (!isApiCallRequired) return;
        const standAloneResultsResponse = yield call(
            get_scrip_company_result,
            Api,
            marketSegmentId,
            nToken,
            'S',
        );
        const standAloneResults = get(
            standAloneResultsResponse,
            'get_company_result_data',
            {},
        );
        let standAloneResultsData = get(standAloneResults, 'data', []);
        standAloneResultsData = formatAnnualReportData(standAloneResultsData);
        const consolidatedResultsResponse = yield call(
            get_scrip_company_result,
            Api,
            marketSegmentId,
            nToken,
            'C',
        );
        const consolidatedResults = get(
            consolidatedResultsResponse,
            'get_company_result_data',
            {},
        );
        let consolidatedResultsData = get(consolidatedResults, 'data', []);
        consolidatedResultsData = formatAnnualReportData(
            consolidatedResultsData,
        );
        const refreshDetails = getShouldRefreshStructure(
            consolidatedResults,
            shouldRefresh,
        );
        const response = {
            data: {
                standalone: standAloneResultsData,
                consolidated: consolidatedResultsData,
            },
            ...refreshDetails,
        };
        yield put(
            setAnnualReportResultsData({ isLoading: false, ...response, foreignKey }),
        );
    } catch (error) {
        yield put(
            setAnnualReportResultsData({
                isLoading: false,
                error: error?.message,
                foreignKey: payload.foreignKey
            }),
        );
        console.log('handleFetchResultsAnnualReport error is', error.message);
    } finally {
        yield put(
            setAnnualReportResultsData({
                isLoading: false,
                foreignKey: payload.foreignKey
            }),
        );
    }
}

function* handleScripRedirection({ payload }) {
    const {
        scripType,
        scripSegment,
        scripToken,
        scripSymbol,
        scripDescription,
        initialTab,
        screenId,
    } = payload;
    const foreignKey = scripDetailsService.getScripDetailForeignKey(scripSegment, scripToken);

    const screenUniqueIdData = {
        scripSymbol,
        scripToken,
        scripSegment,
        screenId,
        foreignKey
    };
    const initialData = {
        scripSymbol,
        scripToken,
        scripSegment,
        scripInstrument: scripType,
        scripDescription,
        initialTab,
    };
    try {
        yield put(setScripDetailsLookUpData(screenUniqueIdData));
        yield put(setInitialData({foreignKey, initialData}));
    } catch (e) {
        console.log('error in handleScripRedirection inside saga');
    }
}
function* handlePullRefreshTechnicalScrip({ payload }) {
    const { Api, nToken = '', segment = '', isPullToRefresh = true, foreignKey, screenId } = payload;
    try {
        const pullRefreshScreen = SCRIP_PULL_REFRESH_SCREEN.TECHNICAL;
        yield put(
            setPullScripDetailLoadingState({
                foreignKey,
                [pullRefreshScreen]: true,
            }),
        );
        yield put(
            setPullScripDetailErrorState({
                foreignKey,
                [pullRefreshScreen]: { status: false, errorMessage: '' },
            }),
        );

        yield all([
            yield put(
                getMovingAverage({
                    Api,
                    nToken: nToken,
                    isPullToRefresh,
                    pullRefreshScreen,
                    screenId,
                    foreignKey,
                }),
            ),
            yield put(
                getVolumeDeliveryChart({
                    Api,
                    marketSegmentId: API_SEGMENT_LABEL_MAPPER[segment],
                    nToken: nToken,
                    isPullToRefresh,
                    pullRefreshScreen,
                    screenId,
                    foreignKey,
                }),
            ),
            yield put(
                getSecurityInfo({
                    Api,
                    nToken: nToken,
                    marketSegmentId: segment,
                    isPullToRefresh,
                    pullRefreshScreen,
                    foreignKey,
                    screenId,
                }),
            ),
        ]);
        yield put(
            setPullScripDetailLoadingState({
                foreignKey,
                [pullRefreshScreen]: false,
            }),
        );
    } catch (err) {
        console.log('error inside handlePullRefreshTechnicalScrip is', err);
    }
}

function* handlePullRefreshFundamentalScrip({ payload }) {
    const { Api, nToken = '', segment = '', isPullToRefresh = true, foreignKey, screenId } = payload;
    try {
        const pullRefreshScreen = SCRIP_PULL_REFRESH_SCREEN.FUNDAMENTAL;
        yield put(
            setPullScripDetailLoadingState({
                foreignKey,
                [pullRefreshScreen]: true,
            }),
        );
        yield put(
            setPullScripDetailErrorState({
                foreignKey,
                [pullRefreshScreen]: { status: false, errorMessage: '' },
            }),
        );

        yield all([
            yield put(
                getFinancialRatio({
                    Api,
                    marketSegmentId: segment,
                    nToken: nToken,
                    isPullToRefresh,
                    pullRefreshScreen,
                    foreignKey,
                    screenId,
                }),
            ),
            yield put(
                getTrendAnalysis({
                    Api,
                    exchange: segment,
                    nToken: nToken,
                    trendType: TREND_ANALYSIS_DATA[0].value,
                    isPullToRefresh,
                    pullRefreshScreen,
                    foreignKey,
                    screenId,
                }),
            ),
            yield put(
                getMfFundHolders({
                    Api,
                    marketSegmentId: segment,
                    nToken: nToken,
                    isPullToRefresh,
                    pullRefreshScreen,
                    foreignKey,
                    screenId,
                }),
            ),
            yield put(
                getShareHolding({
                    Api,
                    marketSegmentId: segment,
                    nToken: nToken,
                    isPullToRefresh,
                    pullRefreshScreen,
                    foreignKey,
                    screenId,
                }),
            ),
            yield put(
                getPeerComparison({
                    Api,
                    marketSegmentId: segment,
                    nToken: nToken,
                    isPullToRefresh,
                    pullRefreshScreen,
                    foreignKey,
                    screenId,
                }),
            ),
            yield put(
                getProfitLossAnnualReport({
                    Api,
                    marketSegmentId: segment,
                    nToken: nToken,
                    isPullToRefresh,
                    pullRefreshScreen,
                    foreignKey,
                    screenId,
                }),
            ),
        ]);
        yield put(
            setPullScripDetailLoadingState({
                foreignKey,
                [pullRefreshScreen]: false,
            }),
        );
    } catch (err) {
        console.log('error inside handlePullRefreshTechnicalScrip is', err);
        yield put(
            setPullScripDetailLoadingState({
                foreignKey,
                [pullRefreshScreen]: false,
            }),
        );
    }
}

function* handlePullRefreshNewsEventScrip({ payload }) {
    const { Api, segment = '', nToken = '', isPullToRefresh = true, foreignKey, screenId } = payload;
    const pullRefreshScreen = SCRIP_PULL_REFRESH_SCREEN.NEWS_EVENT;
    const { fromDate, toDate } = getLastSixMonthDate();
    try {
        yield put(
            setPullScripDetailLoadingState({
                foreignKey,
                [pullRefreshScreen]: true,
            }),
        );
        yield put(
            setPullScripDetailErrorState({
                foreignKey,
                [pullRefreshScreen]: { status: false, errorMessage: '' },
            }),
        );
        yield all([
            yield put(
                getNewsData({
                    Api,
                    marketSegmentId: segment,
                    nToken: nToken,
                    isPullToRefresh,
                    pullRefreshScreen,
                    foreignKey,
                    screenId,
                }),
            ),
            yield put(
                getBoardMeeting({
                    Api,
                    marketSegmentId: segment,
                    nToken: nToken,
                    fromDate: fromDate,
                    toDate: toDate,
                    isPullToRefresh,
                    pullRefreshScreen,
                    foreignKey,
                    screenId,
                }),
            ),
        ]);
        yield put(
            setPullScripDetailLoadingState({
                foreignKey,
                [pullRefreshScreen]: false,
            }),
        );
    } catch (err) {
        console.log('error inside handlePullRefreshFoScrip is', err);
    }
}
function* handlePullRefreshOverviewScrip({ payload }) {
    const { Api, token = '', segment = '', isPullToRefresh = true, screenId, foreignKey } = payload;
    const pullRefreshScreen = SCRIP_PULL_REFRESH_SCREEN.OVERVIEW;
    try {
        yield put(
            setPullScripDetailLoadingState({
                foreignKey,
                [pullRefreshScreen]: true,
            }),
        );
        yield put(
            setPullScripDetailErrorState({
                foreignKey,
                [pullRefreshScreen]: { status: false, errorMessage: '' },
            }),
        );
        yield put(
            fetchScripDetails({
                Api,
                selectedSegmentToken: segment,
                selectedSegment: token,
                isPullToRefresh,
                pullRefreshScreen,
                screenId,
                foreignKey,
            }),
        );
    } catch (err) {
        console.log('error inside handlePullRefreshFoScrip is', err);
    }
}

function* handlePullRefreshConstituentsScrip({ payload }) {
    const {
        Api,
        segment = '',
        indexDesc = '',
        pSize = 50,
        isPullToRefresh = true,
        foreignKey,
        screenId,
    } = payload;
    const pullRefreshScreen = SCRIP_PULL_REFRESH_SCREEN.CONSTITUENTS;

    try {
        yield put(
            setPullScripDetailLoadingState({
                foreignKey,
                [pullRefreshScreen]: true,
            }),
        );
        yield put(
            setPullScripDetailErrorState({
                foreignKey,
                [pullRefreshScreen]: { status: false, errorMessage: '' },
            }),
        );
        yield put(
            getConstituentsData({
                Api,
                exchange: segment,
                indexGroup: encodeURIComponent(indexDesc),
                pSize: pSize,
                isPullToRefresh,
                pullRefreshScreen,
                screenId,
                foreignKey,
            }),
        );
        yield put(
            setPullScripDetailLoadingState({
                foreignKey,
                [pullRefreshScreen]: false,
            }),
        );
    } catch (err) {
        console.log('error inside handlePullRefreshFoScrip is', err);
    }
}

function* handlePullRefreshAnalystScrip({ payload }) {
    const { Api, isin = '', ltp = '', isPullToRefresh = true, foreignKey, screenId } = payload;
    const pullRefreshScreen = SCRIP_PULL_REFRESH_SCREEN.ANALYST;

    try {
        yield put(
            setPullScripDetailLoadingState({
                foreignKey,
                [pullRefreshScreen]: true,
            }),
        );
        yield put(
            setPullScripDetailErrorState({
                foreignKey,
                [pullRefreshScreen]: { status: false, errorMessage: '' },
            }),
        );
        yield put(
            getAnalystData({
                Api,
                isin,
                ltp,
                isPullToRefresh,
                pullRefreshScreen,
                foreignKey,
                screenId,
            }),
        );
        yield put(
            setPullScripDetailLoadingState({
                foreignKey,
                [pullRefreshScreen]: false,
            }),
        );
    } catch (err) {
        console.log('error inside handlePullRefreshAnalystScrip is', err);
        yield put(
            setPullScripDetailLoadingState({
                foreignKey,
                [pullRefreshScreen]: false,
            }),
        );
    }
}
function* handleFetchScripDetails({ payload }) {
    const {
        Api,
        selectedSegmentToken,
        selectedSegment,
        isPullToRefresh = false,
        pullRefreshScreen = '',
        sagaCallback = noop,
        foreignKey,
        screenId,
    } = payload;
    const segment_id = scripDetailsService.mapEquitySegmentToApiSegment(selectedSegment);
    try {
        yield put(resetScripDetailsError(screenId));
        if (!isPullToRefresh) {
            yield put(setScripDetailsLoader({
                isLoading: true,
                screenId: screenId
            }));
        }
        const result = yield call(
            fetch_scrip_details_v2,
            Api,
            selectedSegmentToken,
            segment_id,
        );
        const scripDetailsResult = get(result, 'data', {});
        const nseData = get(scripDetailsResult, 'nse_data', {});
        const bseData = get(scripDetailsResult, 'bse_data', {});
        if (
            commonBaseService.isEmptyOrUndefined(bseData) &&
            commonBaseService.isEmptyOrUndefined(nseData)
        ) {
            throw new Error('No Data Available.');
        }

        yield put(setScripDetails({scripData: scripDetailsResult, selectedSegment, selectedSegmentToken, foreignKey}));
        sagaCallback(scripDetailsResult);
    } catch (err) {
        yield put(setScripDetailsError({
            isFetchFailed: true,
            errorMessage:  err.message,
            screenId: screenId,
        }));
        console.log('error inside handleFetchScripDetails', err);
    } finally {
        yield put(setScripDetailsLoader({
            isLoading: false,
            screenId: screenId
        }));
        if (isPullToRefresh && !isEmptyOrUndefined(pullRefreshScreen)) {
            yield put(
                setPullScripDetailLoadingState({
                    foreignKey,
                    [pullRefreshScreen]: false,
                }),
            );
        }
    }
}

function* handleGetFnoTabData({ payload }) {
    const {
        Api,
        screen = '',
        underlyingToken = '',
        instrumentType = '',
        isIndex = '',
        foreignKey,
        screenId,
    } = payload;
    try {
        yield put(setScripDetailsActionLoaderTrue({ actionName: fetchFnoTabData, screenId }));
        yield put(setError({ screen, isFetchFailed: false, message: '' }));
        const result = yield call(
            fetch_future_list_v2,
            Api,
            underlyingToken,
            instrumentType,
            isIndex,
        );
        const futureListResult = get(result, 'data', {});
        yield put(setLoader({ screen, isFetchingFnoTabData: false }));
        yield put(setFnoTabData({result: futureListResult, foreignKey}));
    } catch (err) {
        console.log('Error inside handleGetFnoTabData...........');
        yield put(
            setScripDetailsActionError({
                actionName: fetchFnoTabData,
                isFetchFailed: true,
                message: err.message,
            }),
        );
    } finally {
        yield put(setScripDetailsActionLoaderFalse({ actionName: fetchFnoTabData, screenId }));

    }
}

function* handleFetchValuation({ payload }) {
    const { Api, screen, data = {}, foreignKey, screenId } = payload;
    try {
        yield put(setScripDetailsActionLoaderTrue({ actionName: fetchValuation, screenId }));
        yield put(setError({ screen, isFetchFailed: false, message: '' }));
        const result = yield call(fetch_valuation, Api, data);
        yield put(setValuation({result, foreignKey}));
    } catch (err) {
        console.log('Error inside handleGetFnoTabData...........', err);
        yield put(
            setScripDetailsActionError({
                actionName: fetchValuation,
                isFetchFailed: true,
                message: err.message,
            }),
        );
    } finally {
        yield put(setScripDetailsActionLoaderFalse({actionName: fetchValuation, screenId}));
    }
}

export default function* sagaFetchUser() {
    yield takeLatest(getFinancialRatio.toString(), handleFetchFinancialRatio);
    yield takeLatest(getTrendAnalysis.toString(), handleFetchTrendAnalysis);
    yield takeLatest(getMfFundHolders.toString(), handleFetchMfFundHolder);
    yield takeLatest(getPeerComparison.toString(), handleFetchPeerComparison);
    yield takeLatest(getAnnualReport.toString(), handleFetchAnnualReport); // NOT BEING USED CHECK ONCE
    yield takeLatest(getAnalystData.toString(), handleFetchAnalystData);
    yield takeLatest(getMovingAverage.toString(), handleFetchMovingAverage);
    yield takeLatest(
        getVolumeDeliveryChart.toString(),
        handleFetchVolumeDeliveryChart,
    );
    yield takeLatest(getSecurityInfo.toString(), handleFetchSecurityInfo);
    yield takeLatest(getNewsData.toString(), handleFetchNewsData);
    yield takeLatest(getBoardMeeting.toString(), handleFetchBoardMeeting);
    yield takeLatest(getBookClosure.toString(), handleFetchBookClosure);
    yield takeLatest(getRights.toString(), handleFetchRights);
    yield takeLatest(getAgm.toString(), handleFetchAgm);
    yield takeLatest(getEgm.toString(), handleFetchEgm);
    yield takeLatest(getSplit.toString(), handleFetchSplit);
    yield takeLatest(getDividend.toString(), handleFetchDividend);
    yield takeLatest(getBuyback.toString(), handleFetchBuyback);
    yield takeLatest(getBonus.toString(), handleFetchBonus);
    yield takeLatest(getShareHolding.toString(), handleFetchShareHoldings);
    yield takeLatest(
        getConstituentsData.toString(),
        handleFetchConstituentsData,
    );
    yield takeLatest(
        getProfitLossAnnualReport.toString(),
        handleFetchProfitLossAnnualReport,
    );
    yield takeLatest(
        getBalanceSheetAnnualReport.toString(),
        handleFetchBalanceSheetAnnualReport,
    );
    yield takeLatest(
        getResultsAnnualReport.toString(),
        handleFetchResultsAnnualReport,
    );
    yield takeLatest(setScripDetailsParams.toString(), handleScripRedirection);
    yield takeLatest(
        pullRefreshTechnicalScrip.toString(),
        handlePullRefreshTechnicalScrip,
    );
    yield takeLatest(
        pullRefreshFundamentalScrip.toString(),
        handlePullRefreshFundamentalScrip,
    );
    yield takeLatest(
        pullRefreshNewsEventScrip.toString(),
        handlePullRefreshNewsEventScrip,
    );
    yield takeLatest(
        pullRefreshOverviewScrip.toString(),
        handlePullRefreshOverviewScrip,
    );
    yield takeLatest(
        pullRefreshConstituentsScrip.toString(),
        handlePullRefreshConstituentsScrip,
    );
    yield takeLatest(
        pullRefreshAnalystScrip.toString(),
        handlePullRefreshAnalystScrip,
    );
    yield takeLatest(fetchScripDetails.toString(), handleFetchScripDetails);
    yield takeLatest(fetchFnoTabData.toString(), handleGetFnoTabData);
    yield takeLatest(fetchValuation.toString(), handleFetchValuation);
}
